import { atom } from 'recoil';

// Feature flags — flip to 1 to re-enable
export const ENABLE_NODE_GLOBE = 1;
export const ENABLE_TOUR = 0;

export const pulseSpeedAtom = atom({
  key: 'pulseSpeed',
  default: 0.1,
});

export const isPausedAtom = atom({
  key: 'isPaused',
  default: false,
});

export const priceDirectionAtom = atom({
  key: 'priceDirection',
  default: 'flat', 
});

export const currencyAtom = atom({
  key: 'currency',
  default: 'USD',
});

export const newBlockTriggerAtom = atom({
  key: 'newBlockTrigger',
  default: 0,
});

export const isMutedAtom = atom({
  key: 'isMuted',
  default: true,
});

export const feePressureAtom = atom({
  key: 'feePressure',
  default: 0,
});

export const mempoolFullnessAtom = atom({
  key: 'mempoolFullness',
  default: 0.5,
});

export const blockTimestampAtom = atom({
  key: 'blockTimestamp',
  default: null,
});

export const focusedBlockIdxAtom = atom({
  key: 'focusedBlockIdx',
  default: null,
});

export const konamiActiveAtom = atom({
  key: 'konamiActive',
  default: false,
});

export const konamiSloganAtom = atom({
  key: 'konamiSlogan',
  default: null,
});

export const genesisBlockAtom = atom({
  key: 'genesisBlock',
  default: false,
});

export const searchedBlockAtom = atom({
  key: 'searchedBlock',
  default: null,
});

export const pizzaDayAtom = atom({
  key: 'pizzaDay',
  default: false,
});

export const powActiveAtom = atom({
  key: 'powActive',
  default: false,
});

export const satsModeAtom = atom({
  key: 'satsMode',
  default: false,
});

export const lightningModeAtom = atom({
  key: 'lightningMode',
  default: false,
});

export const timechainViewAtom = atom({
  key: 'timechainView',
  default: false,
});

export const milestoneAtom = atom({
  key: 'milestone',
  default: false,
});

export const hodlFlashAtom = atom({
  key: 'hodlFlash',
  default: false,
});

export const explorerBlockAtom = atom({
  key: 'explorerBlock',
  default: null,
});

export const explorerTxAtom = atom({
  key: 'explorerTx',
  default: null,
});

export const satsGameAtom = atom({
  key: 'satsGame',
  default: false,
});

export const satsScoreAtom = atom({
  key: 'satsScore',
  default: 0,
});

export const satsPickupAtom = atom({
  key: 'satsPickup',
  default: [],
});

export const nodeMapActiveAtom = atom({
  key: 'nodeMapActive',
  default: false,
});

export const nodeCountAtom = atom({
  key: 'nodeCount',
  default: null,
});

export const HUD_VISIBILITY_DEFAULT = { price: true, block: true, network: true };

export const hudVisibilityAtom = atom({
  key: 'hudVisibility',
  default: HUD_VISIBILITY_DEFAULT,
});

const getInitialWelcomeVisibility = () => {
  try {
    const saved = localStorage.getItem('tesseractWelcomeVisible');
    if (saved === null) return false;
    return saved === 'true';
  } catch {
    return false;
  }
};

export const welcomeMessageVisibleAtom = atom({
  key: 'welcomeMessageVisible',
  default: getInitialWelcomeVisibility(),
});

const BLOCK_CLICK_HINT_KEY = 'blockClickHintDismissed';
const getInitialBlockClickHintDismissed = () => {
  try { return localStorage.getItem(BLOCK_CLICK_HINT_KEY) === '1'; }
  catch { return false; }
};

export const blockClickHintDismissedAtom = atom({
  key: 'blockClickHintDismissed',
  default: getInitialBlockClickHintDismissed(),
  effects: [
    ({ onSet }) => {
      onSet((v) => {
        try { localStorage.setItem(BLOCK_CLICK_HINT_KEY, v ? '1' : '0'); } catch {}
      });
    },
  ],
});
